import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../utilities/AuthContext";
import { db } from "../firebase.js";
import { getDocs, collection, query, where, setDoc } from "firebase/firestore";
import "../components/payment.css";

function loadScript(src) {
	return new Promise((resolve) => {
		const script = document.createElement('script')
		script.src = src
		script.onload = () => {
			resolve(true)
		}
		script.onerror = () => {
			resolve(false)
		}
		document.body.appendChild(script)
	})
}

function Payment() {
	const [name, setName] = useState('Mehul')
	const {currentUser}= useAuth();
	const RAZORPAY_KEY = process.env.REACT_APP_RAZOR_PAY_KEY_ID
	const BASE_URL = process.env.REACT_APP_BASE_URL
	const update_credits = async (credits) => {
		const users= collection(db, "Users");
		const q= query(users, where("uid", "==", currentUser.uid));
		const querySnapshot = await getDocs(q);
		querySnapshot.forEach((doc) => {
			// console.log(doc.data());
			setDoc(doc.ref, {balance: doc.data().balance + credits}, {merge: true});
		});
	}
	async function displayRazorpay(amount, credits) {
		const res = await loadScript('https://checkout.razorpay.com/v1/checkout.js')

		if (!res) {
			alert('Razorpay SDK failed to load. Are you online?')
			return
		}
		// fetch post with body with amount
		// console.log(BASE_URL)
		// console.log(`${BASE_URL}/create_order`)
		const resp = await fetch(`${BASE_URL}/create_order`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				amount: amount * 100
			})
		})
    	const data = await resp.json();

		// console.log(data)
		const options = {
			key: RAZORPAY_KEY,
			currency: data.currency,
			amount: data.amount * 100,
			order_id: data.id,
			name: 'PosterGen',
			description: 'Please pay for your credits',
			// image: 'http://localhost:1337/logo.svg',

			// pass customer details to backend for successful payment
			handler: function (response) {
				// alert(response.razorpay_payment_id)
				// alert(response.razorpay_order_id)
				// alert(response.razorpay_signature)
				// console.log(response)
				fetch(`${BASE_URL}/payment_success`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						amount: amount * 100,
						razorpay_payment_id: response.razorpay_payment_id,
						razorpay_order_id: response.razorpay_order_id,
						razorpay_signature: response.razorpay_signature,
						uid: currentUser.uid
					})
				}).then((t) =>
					t.json()
				)
					.then((data) => {
						// console.log(data)
						if(data.status == "Payment successful") {
							update_credits(credits)
							navigate("/profile");
						}
					})
					.catch((err) => {
						console.log(err)
					})

			},
			prefill: {
				name,
				email: 'sdfdsjfh2@ndsfdf.com',
				phone_number: '9899999999'
			}
		}
		const paymentObject = new window.Razorpay(options)
		paymentObject.open()
	}

  function getCurrentPackage(){
    return "Bronze"
  }

  function Package({pkg}){
	let amt = {
		"bronze": 25,
		"silver": 100,
		"gold": 500,
	}[pkg]
	let credits = {
		25:25,
      100:115,
      500:625,
	}[amt]
    return (
      <div className="w-full p-4">
        <div className="bg-white rounded-sm shadow-md p-4 flex flex-col justify-center">
          <h1 className="my-4 text-3xl">Continue with your payment?</h1>
          {/* <h2 className="mb-2 text-xl">Active plan: <span className="font-bold capitalize">{getCurrentPackage()}</span></h2> */}
          <h2 className="mb-2 text-xl">Plan Opted for: <span className="font-bold capitalize">{pkg}</span></h2>
          <h2 className="mb-2 text-xl">Price: <span className="font-bold capitalize">₹{amt}</span></h2>
			<h2 className="mb-2 text-xl">Credits: <span className="font-bold capitalize">{credits}</span></h2>
          {/* <h2 className="mb-2 text-xl">Validity: <span className="font-bold capitalize">3 Months</span></h2> */}
          <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-2 flex flex-col justify-center items-center m-1" onClick={async ()=>{await displayRazorpay(amt, credits)}}>
            Pay securely using RazorPay
          </button>
        </div>
      </div>
    )
  }

  function Price({price}){
    let credits = {
		25:25,
      100:115,
      500:625,
    }[price];
    return (
      <div className="w-full p-4">
        <div className="bg-white rounded-sm shadow-md p-4 flex flex-col justify-center">
          <h1 className="my-4 text-3xl">Continue with your payment?</h1>
          <h2 className="mb-2 text-xl">Amount: <span className="font-bold capitalize">₹{price}</span></h2>
          <h2 className="mb-2 text-xl">Credits: <span className="font-bold capitalize">{credits}</span></h2>
          <h2 className="mb-2 text-xl">Validity: <span className="font-bold capitalize">Forever</span></h2>
          <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-2 flex flex-col justify-center items-center m-1" onClick={async ()=>{await displayRazorpay(price)}}>
            Pay securely using RazorPay
          </button>
        </div>
      </div>
    )
  }

  let [pkg, setPkg] = useState(null);
  let [price, setPrice] = useState(null);
  let loc = useLocation();
  let navigate = useNavigate();
  useEffect(()=>{
    let params = new URLSearchParams(loc.search);
    let _pkg = params.get("package");
    let _price = params.get("price");
    if((!_pkg && !_price) || (_pkg && _price)) navigate("/pricing");
    else if(_pkg && !_price && (_pkg == "silver" || _pkg == "gold" || _pkg == "bronze")) setPkg(_pkg);
    else if(_price && !_pkg) setPrice(_price);
    else navigate("/pricing");
  })


  if(pkg)
    return <Package pkg={pkg} />
  if(price)
    return <Price price={price} />

  return (
    <div className='app-loader'>
      <img src="/images/loading.svg" alt="" />
    </div>
  )
}

export default Payment